const config = {
  API_URL: process.env.REACT_APP_BACKEND_URL || "http://localhost:3100",
};

export default config;
